export const TEST_ID = 'fieldDetailsPage';

export const CARD_HEADER_DETAIL_TYPE = 'field';

export const DETAIL_TYPE_CLIENT = 'client';

export const DETAIL_TYPE_FARM = 'farm';

export const DETAIL_TYPE_BOUNDARY = 'boundary';
